import { cn } from "@/utils/cn";
import { memo } from "react";

interface CaretDownIconProps {
  className?: string;
}

export const CaretDownIcon = memo(function CaretDownIcon({ className }: CaretDownIconProps) {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path
        d="M10.3668 1.35393L5.82157 6.35337C5.77936 6.39986 5.72923 6.43673 5.67405 6.46189C5.61888 6.48705 5.55973 6.5 5.5 6.5C5.44027 6.5 5.38112 6.48705 5.32594 6.46189C5.27077 6.43673 5.22064 6.39986 5.17842 6.35337L0.633201 1.35393C0.547914 1.26012 0.5 1.13289 0.5 1.00022C0.5 0.867555 0.547914 0.740321 0.633201 0.646511C0.718487 0.552702 0.834161 0.5 0.954775 0.5C1.07539 0.5 1.19106 0.552702 1.27635 0.646511L5.5 5.29287L9.72365 0.646511C9.76588 0.600061 9.81601 0.563215 9.87119 0.538077C9.92636 0.512938 9.9855 0.5 10.0452 0.5C10.1049 0.5 10.1641 0.512938 10.2193 0.538077C10.2744 0.563215 10.3246 0.600061 10.3668 0.646511C10.409 0.692961 10.4425 0.748106 10.4654 0.808795C10.4882 0.869485 10.5 0.934532 10.5 1.00022C10.5 1.06591 10.4882 1.13096 10.4654 1.19165C10.4425 1.25234 10.409 1.30748 10.3668 1.35393Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </svg>
  );
});
